import React from "react";
import styled from "styled-components";
import { createRoot } from "react-dom/client";
import { Dialog, Box } from "@mui/material";

const MODAL_CONTAINER_ID = "modal-container-invite-sent";

const Header = styled.div`
    text-align: center;
    font: normal normal bold 35px/24px Manrope;
    letter-spacing: 0px;
    color: #11141A;
    opacity: 1;
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 0 1rem;
    box-sizing: border-box;
`;

class InviteSentModal {
    static instance;
    static _modalContainer;
    static _modalRoot;

    static init() {
        let exists = document.getElementById(MODAL_CONTAINER_ID);

        if (exists) {
            InviteSentModal.instance = exists;
            InviteSentModal.instance.id = MODAL_CONTAINER_ID;
            document.body.removeChild(InviteSentModal.instance);
        }

        InviteSentModal.instance = document.createElement("div");
        InviteSentModal.instance.id = MODAL_CONTAINER_ID;
        document.body.appendChild(InviteSentModal.instance);
    }

    /**
     * @param {string} modalHeader
     * @param {React.ReactNode} modalBody - React component or JSX to render inside modal body
     * @param {boolean} easyDismiss
     */
    static open(modalHeader = "", modalBody = null, easyDismiss = true) {
        if (!InviteSentModal.instance || !document.getElementById(MODAL_CONTAINER_ID)) {
            InviteSentModal.init();
        }

        const dismissEvent = () => {
            InviteSentModal.close();
        };

        const modalContent = (
            <Dialog
                open={true}
                onClose={easyDismiss ? dismissEvent : null}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: "10px",
                        padding: "2rem 2rem",
                        width: "800px",
                        minHeight: "250px",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        justifyContent: "flex-start",
                    },
                }}
                aria-labelledby="invite-sent-modal-header"
            >
                <Header id="invite-sent-modal-header">{modalHeader}</Header>

                <Box
                    sx={{
                        flexGrow: 1,
                        overflowY: "auto",
                        display: "flex",
                        justifyContent: "left",
                    }}
                >
                    <ContentWrapper>
                        {modalBody}
                    </ContentWrapper>
                </Box>
            </Dialog>
        );

        InviteSentModal._modalContainer = document.createElement("div");
        InviteSentModal.instance.appendChild(InviteSentModal._modalContainer);

        InviteSentModal._modalRoot = createRoot(InviteSentModal._modalContainer);
        InviteSentModal._modalRoot.render(modalContent);
    }

    static close() {
        if (!InviteSentModal._modalContainer) {
            console.warn("There is no modal to close.");
            return;
        }

        InviteSentModal._modalRoot?.unmount();
        InviteSentModal._modalRoot = null;

        if (InviteSentModal._modalContainer.parentNode) {
            InviteSentModal._modalContainer.parentNode.removeChild(InviteSentModal._modalContainer);
            InviteSentModal._modalContainer = null;
        }

        // Also remove main container wrapper div if needed
        if (InviteSentModal.instance && InviteSentModal.instance.parentNode) {
            InviteSentModal.instance.parentNode.removeChild(InviteSentModal.instance);
            InviteSentModal.instance = null;
        }
    }
}

export default InviteSentModal;
